export const API_URL = {
    'pre-sale.store': '/crm/pre-sale/create',
    'pre-log-history.store': '/crm/log-history/store',
    'pre-sale.all': '/crm/pre-sale',
    'pre-sale.update': '/crm/pre-sale/update/:id',
    'pre-sale.show': '/crm/pre-sale/show/:id',
    'log-history.show': '/crm/log-history/show/:id',
    'pre-sale.delete': '/crm/pre-sale/delete/:id',
    'pre-sale.detail': '/crm/pre-sale/detail/:id',

}
